import HeadTag from "@/component/SeoTags/HeadTag";
// import SVG from "react-inlinesvg";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import AdSlot728x90 from "@/component/Ads/AdSlot728x90";
import AdSlot300x250 from "@/component/Ads/AdSlot300x250";
import { useRouter } from "next/router";
import FAQPageSchema from "@/component/SeoTags/FAQPageSchema";
// import { FiArrowRightCircle } from "react-icons/fi";
import useIsMobile, { useWindowSize } from "@/hooks/useIsMobile";
import { useInView } from "react-intersection-observer";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import dynamic from "next/dynamic";
import NoData from "@/component/NoData";
const List1 = dynamic(() => import("@/component/Listing/List1"));
const List2 = dynamic(() => import("@/component/Listing/List2"));
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
import GTMScript from "@/component/Ads/GTMScript";
import ExitPoll from "@/component/ExitPoll";
import ResultTally from "@/component/Result";
import Sponsor from "@/component/Sponsor";
import StateKeyCandidate from "@/component/stateKeyCandidate";
import { capitalizeWords } from "@/utils/articleHtmlSplit";
import RegionalsElectionResultsComponent from "@/component/constituency";
import RegionalsConstituencyResultsComponent from "@/component/constituency/constituencyResult";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import ExitPollRegionalComponentV2 from "@/component/ExitPollRegionalV2";
import StateExitPoll from "@/component/StateExitPoll";
import StateResultTally from "@/component/StateResultTally";
import axios from "axios";
import CandidateProfile from "@/component/CandidateProfile";
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);

const Breadcrumb = dynamic(() =>
  import("@/component/Breadcrumb/ElectionBreadCrumb")
);
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import MainBanner from "@/component/constituency/MainBanner";
import LiveBlogCard from "@/component/constituency/LiveBlogCard";
import BiharConstituencyLiveResult from "@/component/constituency/BiharConstituencyLiveBlogLinks";
import ElectionsTabs from "./ElectionTabs";
import ElectionMainTab from "../FiveStateElection/ElectionMainTab";
// import ElectionMainTab from "../FiveStateElection/ElectionMainTab";
const ElectionSchedule = dynamic(() => import("@/component/Schedule"));
const ConstituencyLinks = dynamic(() =>
  import("@/component/constituency/ConstituencyLinks")
);

const Index = ({
  faqData,
  electionPath = null,
  categoryNewsListData = null,
  isMobileDevice = false,
  constituencyListData = null,
  candidateData = null,
  constHindiName = null,
  constituencyDetailData = null,
  electionPassedCategory = "",
  masterKey = "",
  stateName = "",
  stateHindi = "",
  votingDate = "",
  resultDate = "",
  scheduleDesc = "",
  oldResult = {},
  oldDesc = "",
  newDesc = "",
  metaData = {},
  exitPoll2019Data = [],
  exitPoll2024Data = [],
  resultKey = "",
  candidateProfileData = null,
  candidateList = null,
  liveBlogData = null,
  ConstituencyliveBlogData = null,
  showBanner = true,
}) => {
  const router = useRouter();

  const [activeIndex, setActiveIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const size = useWindowSize();
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig[masterKey];
  const haryanaLogo =
    "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/haryana-kiska-unit.png";
  const jharkhandLogo =
    "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/jharkhand-kiska-logo-unit.png";
  const maharashtraLogo =
    "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/maharashtra-kiska-hindi.png";
  // console.log("electionKeys", electionKeys);
  const menuList = electionKeys?.menuList;
  // const menuList = [
  //   {
  //     title: "खबरें",
  //     src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/khabarSym.svg",
  //     slug: `${electionPassedCategory}`,
  //   },
  //   ...(electionKeys?.showScheduleTab
  //     ? [
  //         {
  //           title: "शेड्यूल",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/calender.svg",
  //           slug: `${electionPassedCategory}/schedule`,
  //         },
  //       ]
  //     : []),
  //   ...(electionKeys?.showConstituencyTab
  //     ? [
  //         {
  //           title: "हर सीट", // "निर्वाचन क्षेत्र",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/chunavSeat.svg", //"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i4.gif",
  //           slug: `${electionPassedCategory}/constituency-list`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showKeyCand
  //     ? [
  //         {
  //           title: "VIP सीट", // "प्रमुख उम्मीदवार",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/keycandidate.svg",
  //           slug: `${electionPassedCategory}/key-candidates-list`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showLiveUpdate
  //     ? [
  //         {
  //           title: "लाइव अपडेट्स", // "प्रमुख उम्मीदवार",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif",
  //           slug: `${electionPassedCategory}/constituency-list#election-auto-live-blogs`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showResult
  //     ? [
  //         {
  //           title: "रिजल्ट", // "चुनाव परिणाम",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/cup.svg",
  //           slug: `${electionPassedCategory}/results`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showExitPoll
  //     ? [
  //         {
  //           title: "एक्जिट पोल",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/archive.svg",
  //           slug: `${electionPassedCategory}/exit-poll`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showFaqs
  //     ? [
  //         {
  //           title: `FAQs`,
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/faqSymbol.svg",
  //           slug: `faqs`,
  //         },
  //       ]
  //     : []),
  // ];

  const [resultDesc, setResultDesc] = useState(
    "हरियाणा विधानसभा c 2024 (Haryana Assembly election 2024) होने वाले हैं. हरियाणा विधानसभा की 90 सीटों पर एक चरण में 8 अक्टूबर को वोटिंग होगी. अब बारी है इन चुनावी नतीजों की. न्यूज Tak की वेबसाइट newstak.in के इस खास सेक्शन में आप हर सीट पर विधानसभा चुनाव के पूरे नतीजे देख सकते हैं. हरियाणा में 2019 के विधानसभा चुनाव में भारतीय जनता पार्टी को 40 सीटों पर जीत मिली थी. बीजेपी अपने दम पर बहुमत हासिल नहीं कर पाई थी. कांग्रेस ने पिछले चुनावों से अच्छा प्रदर्शन करते हुए 30 सीटों पर जीत हासिल की थी. जेजेपी को 10 सीटों पर जीत मिली थी. बाद में बीजेपी ने जेजेपी के साथ मिलकर हरियाणा में सरकार बनाई थी. इंडियन नेशनल लोकदल को सिर्फ एक सीट पर जीत मिली थी. आप हरियाणा विधानसभा चुनाव के इस पेज पर चुनावी नतीजों के साथ सियासी उठापटक की भी लेटेस्ट खबरें देख सकते हैं. प्रदेश और देश की सियासत का हर पहलू समझने के लिए बनें रहें न्यूज Tak के साथ."
  );
  const exitDesc2019 = oldDesc; //"हरियाणा विधानसभा चुनाव 2024 के नतीजे 8 अक्टूबर को आने वाले हैं, लेकिन उससे पहले एग्जिट पोल पर सबकी नजर है. हरियाणा चुनाव में सत्ताधारी बीजेपी के अलावा मुख्य विपक्षी कांग्रेस संग जेजेपी, आईएनएलडी और बसपा जैसी पार्टियां अपनी किस्मत आजमा रही हैं. इस बार का चुनाव किसानों के मुद्दे, रोजगार और महंगाई जैसे इश्यू पर लड़ा गया. बीजेपी को 10 सालों की एंटी इनकंबेंसी का भी सामना करना पड़ेगा. एग्जिट पोल से हरियाणा चुनाव के संभावित नतीजों के बारे में पता चलता है. एग्जिट पोल के डेटा को वोटिंग के आखिरी दिन ही जारी किया जाता है. इसके लिए डेटा कलेक्शन वोटिंग के दिन किया जाता है. वोटिंग के दिन जब वोटर्स वोट डालकर बाहर आते हैं तो उनसे सवाल पूछकर नब्ज टटोली जाती है."
  const exitDesc2024 = newDesc; //"हरियाणा विधानसभा चुनाव 2024 के नतीजे 8 अक्टूबर को आने वाले हैं, लेकिन उससे पहले एग्जिट पोल पर सबकी नजर है. हरियाणा चुनाव में सत्ताधारी बीजेपी के अलावा मुख्य विपक्षी कांग्रेस संग जेजेपी, आईएनएलडी और बसपा जैसी पार्टियां अपनी किस्मत आजमा चुकी हैं. चुनावी नतीजा ईवीएम में कैद हो चुका है. इस बार का चुनाव किसानों के मुद्दे, रोजगार और महंगाई जैसे इश्यू पर लड़ा गया. बीजेपी को 10 सालों की एंटी इनकंबेंसी का भी सामना करना पड़ा. एग्जिट पोल से हरियाणा चुनाव के संभावित नतीजों के बारे में पता चलता है. एग्जिट पोल के डेटा को वोटिंग के आखिरी दिन ही जारी किया जाता है. इसके लिए डेटा कलेक्शन वोटिंग के दिन किया जाता है. वोटिंग के दिन जब वोटर्स वोट डालकर बाहर आते हैं तो उनसे सवाल पूछकर नब्ज टटोली जाती है."
  const [resultData, setResultData] = useState(
    electionKeys?.resultYear == 2020 ? oldResult : []
  );

  useEffect(() => {
    let activeItemIndex = menuList.findIndex(
      (item) => item?.slug === electionPath
    );
    if (activeItemIndex !== -1 && activeItemIndex != 0) {
      setActiveIndex(activeItemIndex);
    }
  }, []);
  const [firstScroll, setFirstScroll] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );
  const [categoryData, setCategoryData] = useState(
    categoryNewsListData?.content
  );
  const isMobile = useIsMobile();

  useEffect(() => {
    setCategoryData(categoryNewsListData?.content);
  }, [categoryNewsListData?.content]);

  useEffect(() => {
    const handleRouteChangeComplete = (url) => {
      setCurrentPage(1);
    };

    router.events.on("routeChangeComplete", handleRouteChangeComplete);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
  }, [router.events]);

  const [insightref, insightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });
  const [mobileInsightref, mobInsightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });
  const currentPath = router?.asPath?.split("?")[0];
  const isMainElectionPath =
    currentPath === `/elections/${electionPassedCategory}`;
  const isScheduleElectionPath =
    currentPath === `/elections/${electionPassedCategory}/schedule`;
  const isKeyCandidatesPath =
    currentPath ==
    (`/elections/${electionPassedCategory}/key-candidates-list` ||
      `/elections/${electionPassedCategory}/key-candidates-list-2024`);
  const isConstituencyListPath = currentPath?.includes(
    `/elections/${electionPassedCategory}/constituency-list`
  );
  const isElectionResultConsistPath = currentPath?.includes(
    `-assembly-constituency-result-`
  );
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [
          currentPath.split("/")[1],
          currentPath.split("/")[2],
          currentPath.split("/")[3] ?? "",
          currentPath.split("/")[4] ?? "",
        ]
        : currentPath.split("/")[1],
    Keywords: metaData?.keywords,
  };
  // candidate profile page
  const isCandidateProfilePath = currentPath?.includes(
    `/elections/assembly-chunav/bihar/candidates/`
  );

  const isFaqRoute = currentPath?.includes(`/elections/faqs`);
  const isResultRoute =
    currentPath == `/elections/${electionPassedCategory}/results`;
  const isExitPollRoute =
    currentPath === `/elections/${electionPassedCategory}/exit-result` ||
    currentPath === `/elections/${electionPassedCategory}/exit-poll`;

  const [constituencyName, constituencyId] = useMemo(() => {
    const constituencyName = capitalizeWords(
      currentPath
        .split("-assembly-constituency-result-")[0]
        .split("/")
        .pop()
        ?.replace("-", " ")
    );
    const constituencyId = currentPath?.split("-")?.pop();
    return [constituencyName, constituencyId];
  }, []);

  // candidate
  const capitalizeWords2 = (str) =>
    str
      ?.split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  const [candidateName, candidateConstiName, candidateConstituencyId] =
    useMemo(() => {
      const pathSegments = currentPath
        .split("/candidates/")[1]
        ?.split("-result-");

      // Extract candidate name
      const candidateName = capitalizeWords2(pathSegments?.[0] ?? "");

      // Extract constituency name and ID
      const constituencyParts = pathSegments?.[1]?.split("-");
      const candidateConstituencyId = constituencyParts?.slice(-2).join("-"); // Last two parts as ID

      // Remove numeric parts from the constituency name
      const candidateConstiName = capitalizeWords2(
        constituencyParts?.slice(0, -2).join("-") ?? ""
      );

      return [candidateName, candidateConstiName, candidateConstituencyId];
    }, [currentPath]);

  // console.log("candidateName", candidateName, candidateConstiName);
  const fetchPartiesData = async () => {
    try {
      const resData = await axios.get(
        `https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyResultData.json`
      );

      const partyArr = resData.data[0]["partiesDataBR"];

      // console.log("the response is", partyArr);
      let tempArray = [];
      // if (partyArr.data2024 == 1) {
      // console.log('inside loop' , partyArr.data2024)
      for (let eachData of partyArr) {
        let obj = {
          partyName: eachData.partyName,
          partySeat: eachData.seatShare,
        };
        tempArray.push(obj);
      }
      // console.log('the tempAr' , tempArray);
      let finalObj = {
        partyData: tempArray,
      };
      setResultData(finalObj);
      setResultDesc(
        "हरियाणा विधानसभा चुनाव 2024 (Haryana Assembly election 2024) पूरे हो चुके हैं.  हरियाणा विधानसभा की 90 सीटों पर एक चरण में 5 अक्टूबर को वोटिंग हुई. अब बारी है इन चुनावी नतीजों की. न्यूज Tak की वेबसाइट newstak.in के इस खास सेक्शन में आप हर सीट पर विधानसभा चुनाव के पूरे नतीजे देख सकते हैं. हरियाणा में 2019 के विधानसभा चुनाव में भारतीय जनता पार्टी को 40 सीटों पर जीत मिली थी. बीजेपी अपने दम पर बहुमत हासिल नहीं कर पाई थी. कांग्रेस ने पिछले चुनावों से अच्छा प्रदर्शन करते हुए 30 सीटों पर जीत हासिल की थी. जेजेपी को 10 सीटों पर जीत मिली थी. बाद में बीजेपी ने जेजेपी के साथ मिलकर हरियाणा में सरकार बनाई थी. इंडियन नेशनल लोकदल को सिर्फ एक सीट पर जीत मिली थी. आप हरियाणा विधानसभा चुनाव के इस पेज पर चुनावी नतीजों के साथ सियासी उठापटक की भी लेटेस्ट खबरें देख सकते हैं. प्रदेश और देश की सियासत का हर पहलू समझने के लिए बनें रहें न्यूज Tak के साथ."
      );
      // }
    } catch (error) {
      console.log("the error in fetching data is", error);
    }
  };
  // console.log("categoryNewsListData",categoryNewsListData)
  useEffect(() => {
    if (isResultRoute && electionKeys?.resultYear == 2025) {
      // console.log("calling fetch parties")
      fetchPartiesData();

      // Set up the interval to call the function every 20 seconds
      const interval = setInterval(fetchPartiesData, 10000);

      // Clean up the interval when the component unmounts
      return () => clearInterval(interval);
    }
  }, [isResultRoute]);

  const getMorePost = async () => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    setLoadingSpinner(true);
    const fetchedData = await getDataFromSSR(
      `${websiteUrl}/api/getCategoryPosts?page=${currentPage}&category=/elections/${electionPassedCategory}`
    );
    if (fetchedData?.data?.categoryNewsListData?.content?.length > 0) {
      setCategoryData([
        ...(categoryData || []),
        ...fetchedData?.data?.categoryNewsListData?.content,
      ]);
    } else {
      setHasMore(false);
    }
    setLoadingSpinner(false);
  };

  const handleClick = () => {
    router.push(`/elections/${electionPassedCategory}`); // Replace '/desired-path' with your actual path
  };

  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection("Scrolling Up");
      } else if (y < window.scrollY) {
        setScrollDirection("Scrolling Down");
      }

      setY(window.scrollY);
    },
    [y]
  );
  useEffect(() => {
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  useEffect(() => {
    if (
      (insightView || mobInsightView) &&
      scrollDirection == "Scrolling Down" &&
      hasMore
    ) {
      if (!firstScroll) {
        setFirstScroll(true);
      }
      setCurrentPage(currentPage + 1);
    }
  }, [insightView, mobInsightView, scrollDirection]);

  useEffect(() => {
    currentPage >= 1 && getMorePost();
    let height = window?.scrollY;
    window.scrollTo(0, height);
  }, [currentPage]);

  const [isRegionalTab, setIsRegionalTab] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1659434453897-0"
            )
            .addService(googletag.pubads());

          {
            document.getElementById("div-gpt-ad-1659434604998-0") &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434604998-0"
                )
                .addService(googletag.pubads());
          }
          if (
            categoryNewsListData &&
            categoryNewsListData?.content?.length > 5
          ) {
            document.getElementById("div-gpt-ad-1659434785315-0") &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434785315-0"
                )
                .addService(googletag.pubads());
          }
          document.getElementById("div-gpt-ad-1659435474737-0") &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
          googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_728x90",
              [728, 90],
              "div-gpt-ad-1659424515060-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1707804176041-1"
            )
            .addService(googletag.pubads());
          // if (
          //   categoryNewsListData &&
          //   categoryNewsListData?.content?.length > 7
          // ) {
          //   googletag
          //     .defineSlot(
          //       "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
          //       [728, 90],
          //       "div-gpt-ad-1707804176041-2"
          //     )
          //     .addService(googletag.pubads());
          // }
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_BTF_728x90",
              [728, 90],
              "div-gpt-ad-1659425743360-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
        });
      }
      window.apstag?.fetchBids(
        {
          slots:
            window.screen.width < 900
              ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
              : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
          timeout: 2e3,
        },
        apstagBidCallback
      );
    }, 10);
  }, []);

  const BreadcrumbListUpdated = isMainElectionPath
    ? categoryNewsListData?.category_detail
    : isScheduleElectionPath
      ? [
        {
          id: "322111",
          title: "चुनाव",
          canonical_url: "/elections",
          amp_url: "/amp/elections",
        },
        {
          id: "322111",
          title: `${stateHindi} चुनाव`,
          canonical_url: `/elections/${electionPassedCategory}`,
          amp_url: "/amp/elections",
        },
        // {
        //   id: "322112",
        //   title: "लोकसभा चुनाव 2024",
        //   canonical_url: "/elections/${electionPassedCategory}",
        //   amp_url: "/amp/elections/${electionPassedCategory}",
        // },
        {
          id: "3221124354",
          title: "शेड्यूल",
          canonical_url: `/elections/${electionPassedCategory}/schedule`,
          amp_url: `/amp/elections/${electionPassedCategory}/schedule`,
        },
      ]
      : isFaqRoute
        ? [
          {
            id: "322111",
            title: "चुनाव",
            canonical_url: "/elections",
            amp_url: "/amp/elections",
          },
          // {
          //   id: "322111",
          //   title: `${stateHindi} विधानसभा चुनाव`,
          //   canonical_url: `/elections/${electionPassedCategory}`,
          //   amp_url: "/amp/elections",
          // },
          {
            id: "322112",
            title: `FAQs`,
            canonical_url: `/elections/faqs`,
            amp_url: "/amp/elections",
          },
        ]
        : isConstituencyListPath
          ? [
            {
              id: "322111",
              title: "चुनाव",
              canonical_url: "/elections",
              amp_url: "/amp/elections",
            },
            {
              id: "322111",
              title: `${stateHindi} विधानसभा चुनाव`,
              canonical_url: `/elections/${electionPassedCategory}`,
              amp_url: "/amp/elections",
            },
            {
              id: "322112",
              title: "निर्वाचन क्षेत्र",
              canonical_url: `/elections/${electionPassedCategory}/constituency-list`,
              amp_url: `/amp/elections/${electionPassedCategory}/constituency-list`,
            },
          ]
          : isElectionResultConsistPath
            ? [
              {
                id: "322111",
                title: "चुनाव",
                canonical_url: "/elections",
                amp_url: "/amp/elections",
              },
              {
                id: "322111",
                title: `${stateHindi} चुनाव`,
                canonical_url: `/elections/${electionPassedCategory}`,
                amp_url: "/amp/elections",
              },
              {
                id: "322112",
                title: "निर्वाचन क्षेत्र",
                canonical_url: `/elections/${electionPassedCategory}/constituency-list`,
                amp_url: `/amp/elections/${electionPassedCategory}/constituency-list`,
              },
              {
                id: "322112",
                title: constituencyName + " Election Result",
                canonical_url: `/elections/${electionPassedCategory}/${constituencyName
                  .toLowerCase()
                  .replace(/[^a-zA-Z ]/g, "")
                  .split(" ")
                  .join("-")}-assembly-constituency-result-${constituencyId}`,
                amp_url: `/elections/${electionPassedCategory}/${constituencyName
                  .toLowerCase()
                  .replace(/[^a-zA-Z ]/g, "")
                  .split(" ")
                  .join("-")}-assembly-constituency-result-${constituencyId}`,
              },
            ]
            : isCandidateProfilePath
              ? [
                {
                  id: "322111",
                  title: "चुनाव",
                  canonical_url: "/elections",
                  amp_url: "/amp/elections",
                },
                {
                  id: "322111",
                  title: `${stateHindi} चुनाव`,
                  canonical_url: `/elections/${electionPassedCategory}`,
                  amp_url: "/amp/elections",
                },
                {
                  id: "322112",
                  title: "उम्मीदवार",
                  canonical_url: `/elections/${electionPassedCategory}/constituency-list`,
                  amp_url: `/amp/elections/${electionPassedCategory}/constituency-list`,
                },
                {
                  id: "322112",
                  title:
                    candidateName + " " + candidateConstiName + " " + "Election Result",
                  canonical_url: `/elections/${electionPassedCategory}/candidates/${candidateName
                    .toLowerCase()
                    .replace(/[^a-zA-Z ]/g, "")
                    .split(" ")
                    .join("-")}-result-${candidateConstiName
                      ?.toLowerCase()
                      .replace(/[^a-zA-Z ]/g, "")
                      .split(" ")
                      .join("-")}-${candidateConstituencyId}`,
                  amp_url: `/elections/${electionPassedCategory}/candidates/${candidateName
                    .toLowerCase()
                    .replace(/[^a-zA-Z ]/g, "")
                    .split(" ")
                    .join("-")}-result-${candidateConstiName
                      ?.toLowerCase()
                      .replace(/[^a-zA-Z ]/g, "")
                      .split(" ")
                      .join("-")}-${candidateConstituencyId}`,
                },
              ]
              : isResultRoute
                ? [
                  {
                    id: "322111",
                    title: "चुनाव",
                    canonical_url: "/elections",
                    amp_url: "/amp/elections",
                  },
                  {
                    id: "322111",
                    title: `${stateHindi} चुनाव`,
                    canonical_url: `/elections/${electionPassedCategory}`,
                    amp_url: "/amp/elections",
                  },
                  {
                    id: "322112",
                    title: "चुनाव परिणाम",
                    canonical_url: `/elections/${electionPassedCategory}/results`,
                    amp_url: `/amp/elections/${electionPassedCategory}/results`,
                  },
                ]
                : isExitPollRoute
                  ? [
                    {
                      id: "322111",
                      title: "चुनाव",
                      canonical_url: "/elections",
                      amp_url: "/amp/elections",
                    },
                    {
                      id: "322111",
                      title: `${stateHindi} चुनाव`,
                      canonical_url: `/elections/${electionPassedCategory}`,
                      amp_url: "/amp/elections",
                    },
                    {
                      id: "322112",
                      title: "एक्जिट पोल",
                      canonical_url: `/elections/${electionPassedCategory}/exit-poll`,
                      amp_url: `/amp/elections/${electionPassedCategory}/exit-poll`,
                    },
                  ]
                  : isKeyCandidatesPath
                    ? [
                      {
                        id: "322111",
                        title: "चुनाव",
                        canonical_url: "/elections",
                        amp_url: "/amp/elections",
                      },
                      {
                        id: "322111",
                        title: `${stateHindi} चुनाव`,
                        canonical_url: `/elections/${electionPassedCategory}`,
                        amp_url: "/amp/elections",
                      },
                      {
                        id: "322112",
                        title: "प्रमुख उम्मीदवार",
                        canonical_url: `/elections/${electionPassedCategory}/key-candidates-list`,
                        amp_url: `/amp/elections/${electionPassedCategory}/key-candidates-list`,
                      },
                    ] : [
                      {
                        id: "322111",
                        title: "चुनाव",
                        canonical_url: "/elections",
                        amp_url: "/amp/elections",
                      },
                      {
                        id: "322111",
                        title: `${stateHindi} चुनाव`,
                        canonical_url: `/elections/${electionPassedCategory}`,
                        amp_url: "/amp/elections",
                      },
                    ];

  useEffect(() => {
    if (
      currentPath === `/elections/faqs` &&
      typeof window.jQuery !== "undefined"
    ) {
      jQuery(document).ready(function () {
        function close_accordion_section() {
          jQuery(".accordion .accordion-section-title").removeClass("active");
          jQuery(".accordion .accordion-section-content")
            .slideUp(300)
            .removeClass("open");
        }
        jQuery(".accordion-section-title").unbind();

        jQuery(".accordion-section-title").click(function (e) {
          // Grab current anchor value
          var currentAttrValue = jQuery(this).attr("href");
          // console.log("currentAttrValue", currentAttrValue);

          if (jQuery(e.target).is(".active")) {
            console.log("1 ----");
            close_accordion_section();
          } else {
            // close_accordion_section();
            console.log("2 ----");

            // Add active class to section title
            jQuery(this).addClass("active");
            // Open up the hidden content panel
            jQuery(".accordion " + currentAttrValue)
              .slideDown(300)
              .addClass("open");
          }
          e.preventDefault();
        });
      });
    }
  }, []);
  // scroll down
  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#election-auto-live-blogs") {
      const scrollToSection = () => {
        const element = document.getElementById("election-auto-live-blogs");
        if (element) {
          // First jump instantly to element (no smooth)
          element.scrollIntoView({ behavior: "instant", block: "start" });

          // Then do a single smooth correction after short delay
          setTimeout(() => {
            const offset = 180; // adjust this for your sticky header height
            const top = element.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: "smooth" });
          }, 200);
          return true;
        }
        return false;
      };

      if (!scrollToSection()) {
        const interval = setInterval(() => {
          if (scrollToSection()) clearInterval(interval);
        }, 300);
        setTimeout(() => clearInterval(interval), 5000);
      }
    }
  }, []);


  // console.log("electionKeys", electionKeys);
  const [readMore, setReadMore] = useState(true);
  return (
    <article>
      {/* {currentPath === "/elections/faqs" && (
        <HeadTag
          title="Lok Sabha Election 2024 FAQs in Hindi | | MP लोकसभा चुनाव 2024 में पूछे जाने वाले प्रश्न"
          description="Discover the commonly asked questions & answers related to Lok Sabha Elections 2024 (FAQs). हिंदी में जानिए 2024 के सामान्य चुनावों में आमतौर पर पूछे जाने वाले प्रश्नों और उत्तरों (FAQs)."
          keywords="election 2024, lok sabha elections faqs 2024, MP election faqs, lok sabha election faqs, election news, लोकसभा चुनाव 2024, लोकसभा चुनाव 2024 सवाल जवाब"
          canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
        />
      )} */}
      {isMainElectionPath && (
        <HeadTag
          title={categoryNewsListData?.seo_detail?.meta_title}
          description={categoryNewsListData?.seo_detail?.meta_description}
          keywords={categoryNewsListData?.seo_detail?.meta_keyword}
          canonicalUrl={
            process.env.NEXT_PUBLIC_WEBSITE_URL +
            categoryNewsListData?.seo_detail?.canonical_url
          }
          image={categoryNewsListData?.seo_detail?.og_image}
        //  lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
        />
      )}
      {isKeyCandidatesPath && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}

      {isCandidateProfilePath && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isScheduleElectionPath && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isFaqRoute && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isConstituencyListPath && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isElectionResultConsistPath && (
        <>
          <HeadTag
            // title={metaData?.title}
            // description={metaData?.description}
            // keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isResultRoute && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isExitPollRoute && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      <GTMScript />

      <Breadcrumb breadcrumbList={BreadcrumbListUpdated} />
      {isFaqRoute && <FAQPageSchema />}
      {<ItemsListSchema data={categoryNewsListData?.content} />}
      {isMainElectionPath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
          ]}
        />
      )}
      {isFaqRoute && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            // {
            //   title: `${stateHindi} चुनाव`,
            //   canonical_url:
            //     process.env.NEXT_PUBLIC_WEBSITE_URL +
            //     `/elections/${electionPassedCategory}`,
            // },
            {
              title: `विधानसभा चुनाव से जुड़े सवाल जवाब`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL + `/elections/faqs`,
            },
          ]}
        />
      )}
      {isKeyCandidatesPath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "प्रमुख उम्मीदवार",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/key-candidates-list`,
            },
          ]}
        />
      )}
      {/* candidate breadcrumb */}
      {isCandidateProfilePath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "उम्मीदवार",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/key-candidates-list`,
            },
            {
              title:
                candidateName + " " + candidateConstiName + " Election Result",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/candidates/${candidateName
                  ?.toLowerCase()
                  .replace(/[^a-zA-Z ]/g, "")
                  .split(" ")
                  .join("-")}-result-${candidateConstiName
                    ?.toLowerCase()
                    ?.replace(/[^a-zA-Z ]/g, "")
                    .split(" ")
                    .join("-")}-${candidateConstituencyId}`,
            },
          ]}
        />
      )}
      {isScheduleElectionPath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "शेड्यूल",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/schedule`,
            },
          ]}
        />
      )}
      {isConstituencyListPath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "निर्वाचन क्षेत्र",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/constituency-list`,
            },
          ]}
        />
      )}
      {isElectionResultConsistPath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "निर्वाचन क्षेत्र",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/constituency-list`,
            },
            {
              title: constituencyName + " Election Result",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/${constituencyName
                  .toLowerCase()
                  .replace(/[^a-zA-Z ]/g, "")
                  .split(" ")
                  .join("-")}-assembly-constituency-result-${constituencyId}`,
            },
          ]}
        />
      )}
      {isResultRoute && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "चुनाव परिणाम",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/results`,
            },
          ]}
        />
      )}
      {isExitPollRoute && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "एक्जिट पोल",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/exit-poll`,
            },
          ]}
        />
      )}

      <div className="mx-4">
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
      </div>
      {showBanner && <MainBanner electionKeys={electionKeys} />}
      <Sponsor color="#EE3436" name="चुनाव" electionKeys={electionKeys} />
      {/* five states elections tabs */}
      {isFaqRoute && <ElectionMainTab />}
      <div>
        {/* Left-aligned items */}
        {/* <div className="flex gap-3   flex-row overflow-x-scroll scrollbar-hide mt-2 mx-4 md:mx-4">
          {menuList?.map((item, index) => (
            <a
              className={`${
                currentPath === `/elections/${menuList[index]?.slug}` ||
                (currentPath.includes("-assembly-constituency-result-") &&
                  menuList[index]?.slug ===
                    `${electionPassedCategory}/constituency-list`)
                  ? "bg-[#CF4C9B] text-white border-2 border-[#CF4C9B]"
                  : "border-2 text-gray-600 hover:text-[#CF4C9B]"
              } px-3 py-1 rounded-xl whitespace-nowrap flex flex-row items-center gap-1 justify-center `}
              href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/elections/${menuList[index]?.slug}`}
              key={item?.slug}
              target={"_self"}
            >
              <div style={{ minWidth: "1rem" }}>
                {[
                  "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif",
                  "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i6.gif",
                  "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i4.gif",
                  "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/chunavSeat.svg",
                ].some((icon) => item?.src?.includes(icon)) ? (
                  <img
                    className="h-4 w-4"
                    src={
                      currentPath?.includes("-assembly-constituency-result-") ||
                      currentPath?.includes("constituency-list")
                        ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/constiseat.svg"
                        : item?.src
                    }
                  />
                ) : (
                  <SVG className="h-4 w-4" src={item?.src} />
                )}
              </div>
              <p>{item?.title}</p>
            </a>
          ))}
        </div> */}

        {showBanner && <ElectionsTabs menuList={menuList} currentPath={currentPath} electionPassedCategory={electionPassedCategory} />}

        {electionKeys?.newExitPoll && !isExitPollRoute && (
          <div className="mx-4 md:mx-4  ">
            <h2 className="text-2xl font-semibold my-1">एग्जिट पोल्स</h2>
            <ExitPollRegionalComponentV2 masterKey={masterKey} />
          </div>
        )}
        {!isExitPollRoute && electionKeys?.showExitPollTally && (
          <div className="mx-4 md:mx-4  ">
            <StateExitPoll
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
              stateName={stateName}
              stateHindi={stateHindi}
            />
          </div>
        )}
        {!isResultRoute && (
          <div className="mx-4  md:mx-4 " >
            <StateResultTally
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
              stateHindi={stateHindi}
              constHindiName={constHindiName}
            // className="py-4"
            />
          </div>
        )}

        {<ExitPoll />}
        {<ResultTally />}
        {isFaqRoute && (
          <h1 className="mx-4 my-3 text-2xl font-semibold">
            Assembly Election 2026 FAQs
          </h1>
        )}
        {currentPath === `/elections/faqs` && (
          <>
            <p className={`  mx-4 `}>
              देश के पांच राज्यों, पश्चिम बंगाल, असम, तमिलनाडु, केरल और पुडुचेरी
              में विधानसभा चुनावों का ऐलान हो चुका है. पश्चिम बंगाल में ममता
              बनर्जी फिर रिपीट करेंगी या बीजेपी इस बार करेगी कोई बड़ा खेला. असम
              में हेमंत बिस्वा पर जनता कितना विश्वास करेगी. तमिलनाडु में TVK
              बनेगी बड़ा टर्निंग प्वाइंट या केरल की जनता वाम दलों फिर करेगी
              भरोसा. पुडुचेरी में ऊंट किस करवट बैठेगा...इन सभी सवालों का जवाब 4
              मई 2026 को मिल जाएंगे. हालांकि इससे पहले मतदान से लेकर चुनावी
              प्रक्रिया से जुड़े कई सवाल जनता के मन में हैं जिसका जवाब हम F&Qs
              में दे रहे हैं.
            </p>
            <div
              className={`mt-4 flex flex-col gap-4 text-gray-500 text-md font-extralight mx-2 `}
            >
              <p
                dangerouslySetInnerHTML={{
                  __html: `${faqData?.content?.description_short}`,
                }}
              ></p>
            </div>
          </>
        )}

        {isScheduleElectionPath && (
          <div className="mx-4 mt-4">
            {/* <h1 style={{display:"none"}}>{`${stateName} Assembly Election 2024: Schedule`}</h1> */}
            <h1 className="text-[#CF4C9B] font-bold text-2xl mb:font-extrabold sm:font-extrabold xs:font-extrabold">
              विधानसभा चुनाव 2025 शेड्यूल
            </h1>
            <ElectionSchedule />

            <div className={`text-[#323232]  text-left relative inline `}>
              <p
                className={`${readMore ? "line-clamp-2" : ""
                  } text-justify mt-2`}
              >
                {scheduleDesc}{" "}
              </p>
              <span
                onClick={() => {
                  setReadMore((prev) => !prev);
                }}
                className="cursor-pointer inline -ml-[0.5px]  text-[#CF4C9B] text-sm"
              >
                {readMore ? "और पढ़ें >" : "< कम पढ़ें"}
              </span>
            </div>
          </div>
        )}
        {isConstituencyListPath && (
          <div>
            <div className="px-2 mx-5">
              <h1 className="text-[#CF4C9B] font-bold text-2xl md:font-extrabold sm:font-extrabold xs:font-extrabold mt-2">
                Winning Candidate List of {stateName} Assembly Election 2025
              </h1>
              <h2 className="mb-2">
                {`आगामी बिहार विधानसभा चुनाव 2025 में दो चरणों में 6 नवंबर और 11 नवंबर, 2025 को मतदान होगा. मतगणना 14 नवंबर, 2025 को होगी. चुनाव में मुख्य मुकाबला एनडीए और महागठबंधन के बीच होने की उम्मीद है. एनडीए में भाजपा और जेडी(यू) 101-101 सीटों पर चुनाव लड़ने के लिए सहमत हुए हैं, जबकि लोक जनशक्ति पार्टी (रामविलास) और छोटे सहयोगी दल शेष सीटों पर चुनाव लड़ेंगे. विपक्ष की महागठबंधन में राजद, कांग्रेस, वामपंथी दल और अन्य क्षेत्रीय दल मैदान में हैं.`}
              </h2>
              {/* <h1 style={{display:"none"}}>LIVE: {stateHindi} विधानसभा विजेता उम्मीदवार </h1> */}
              {electionKeys?.showContentConstituency2020 && <>
                <h2 className="text-[#CF4C9B] font-bold text-2xl mb:font-extrabold sm:font-extrabold xs:font-extrabold">
                  Winning Candidate List of {stateName} Assembly Election 2020
                  {/* 2019 Constituency */}
                </h2>
                <h2>
                  {`बिहार विधानसभा चुनाव 2020 में NDA ने 125 सीटें जीतीं थीं. 2015 के मुकाबले NDA को 67 सीटों की बढ़त मिली. हालांकि 2015 में जेडीयू NDA का पार्ट नहीं थी. उसने RJD के साथ मिलकर चुनाव लड़ा था. 2020 में महागठबंधन को 110 सीटें मिली थी. 2015 के मुकाबले महागठबंधन को 68 सीटों का नुकसान हुआ था. 2020 में अन्य को 8 सीटें मिली थीं.`}
                </h2>
              </>}
            </div>
            <RegionalsElectionResultsComponent
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
              constituencyListData={constituencyListData}
            />
            {/* <iframe
              src={`https://elections.mobiletak.com/regionals/elections/constituency-list-2019/up?base-url=${process.env.NEXT_PUBLIC_WEBSITE_URL}`}
              width={"100%"}
              height={isMobile ? 3300 : 3054}
            /> */}
          </div>
        )}
        {isElectionResultConsistPath && (
          <div className="my-4 mx-2">
            <div className="px-2">
              {/* <h1 style={{display:"none"}}>LIVE {constituencyName} विधानसभा सीट परिणाम or {stateName} Assembly Election Results 2024 |</h1> */}
              <h1 className="text-[#CF4C9B] font-bold text-2xl mb:font-extrabold sm:font-extrabold xs:font-extrabold">
                {constHindiName} विधानसभा चुनाव 2025 ({constituencyName}{" "}
                Assembly Election 2025)
              </h1>
              <h3>
                {/* {constHindiName} {stateHindi} विधानसभा चुनाव परिणाम{" "}
                {electionKeys?.constDetailYear}:- {stateHindi} विधानसभा चुनाव
                2020 में {constituencyName} सीट पर किसे मिली थाी जीत, किसे मिली
                थी हार? तीसरे स्थान पर कोई निर्दलीय रहा या किसी पार्टी का
                कैंडिडेट. 2015 में {constituencyName} सीट पर किन दलों के बीच था
                मुकाबला और किसे मिली थी जीत. हम आपके लिए लाए हैं सारी जानकारी.
                2025 के चुनाव की हर सीट का रिजल्ट भी आपको यहीं मिलेगा न्यूज Tak
                पर. */}
                बिहार की {constHindiName} विधानसभा सीट पर कौन लीड कर रहा है?
                दूसरे नंबर पर कौन है? क्या कोई निर्दलीय बिगाड़ रहा है सियासी
                खेल? सीट का पूरा जोड़-घटाना जानिए बस एक क्लिक में. हर एक राउंड
                में वोटों की गिनती की सबसे तेज और सटीक जानकारी केवल newstak.in
                पर देखें.
              </h3>
            </div>
            <RegionalsConstituencyResultsComponent
              constHindiName={constHindiName}
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
              constituencyTempListData={constituencyListData}
              candidateData={candidateData}
              constituencyDetailData={constituencyDetailData}
              constituencyName={constituencyName}
              stateName={stateName}
            />
            {ConstituencyliveBlogData && (
              <LiveBlogCard constituencyDetailData={ConstituencyliveBlogData} />
            )}
            <ConstituencyLinks
              constituencyListData={constituencyListData}
              customTitle={`${stateHindi} विधानसभा निर्वाचन क्षेत्र`}
              electionPassedCategory={electionPassedCategory}
            />
            {/* <iframe
              src={`https://elections.mobiletak.com/regionals/elections/constituency-list-2019/${constituencyId}/up?state-id=S24`}
              width={"100%"}
              height={900}
            /> */}
          </div>
        )}
        {/* mtf-1 code  */}

        {isResultRoute && (
          <div className=" mx-3">
            <h1
              style={{ display: "none" }}
            >{`${stateHindi} विधानसभा चुनाव परिणाम ${electionKeys?.resultYear}`}</h1>
            <div className="mt-4" style={{ padding: "10px" }}>
              <div
                style={{
                  borderBottom: "2px solid #E5E5E5",
                  padding: "15px",
                  paddingLeft: "0",
                }}
              >
                <h2
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    color: "#000",
                  }}
                >
                  {stateHindi} विधानसभा चुनाव परिणाम {electionKeys?.resultYear}
                </h2>
              </div>
              <div style={{ marginTop: "1px" }}>
                <p>{electionKeys?.resultYear == 2020 ? oldDesc : newDesc}</p>
              </div>
              {resultData?.partyData?.length > 0 && <div class="table_cont" style={{ marginTop: "15px" }}>
                <div class="tbbody">
                  <div
                    class="tbhead"
                    style={{
                      backgroundColor: "#D71920",
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderTopLeftRadius: "4px",
                      borderTopRightRadius: "4px",
                    }}
                  >
                    <div style={{ marginLeft: "5%" }}>
                      <p
                        style={{
                          fontWeight: 700,
                          fontSize: "1.25rem",
                          color: "#FFF",
                        }}
                      >
                        Party
                      </p>
                    </div>
                    <div style={{ marginRight: "5%" }}>
                      <p
                        style={{
                          fontWeight: 700,
                          fontSize: "1.25rem",
                          color: "#FFF",
                        }}
                      >
                        Total
                      </p>
                    </div>
                  </div>
                  {resultData.partyData &&
                    resultData.partyData.length > 0 &&
                    resultData.partyData.map((item, index) => {
                      return (
                        <div
                          key={index}
                          class="tbhead"
                          style={{
                            backgroundColor:
                              index % 2 == 0 ? "#EEF3F7" : "#FBFBFB",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px",
                            borderTopLeftRadius: "4px",
                            borderTopRightRadius: "4px",
                          }}
                        >
                          <div style={{ marginLeft: "5%" }}>
                            <p style={{ color: "#777777" }}>{item.partyName}</p>
                          </div>
                          <div style={{ marginRight: "5%" }}>
                            <p style={{ fontWeight: 700, color: "#000" }}>
                              {item.partySeat}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>}
            </div>
          </div>
        )}
        {isExitPollRoute && (
          <>
            <h1
              className="mx-4 my-3  font-bold text-2xl mb:font-extrabold sm:font-extrabold xs:font-extrabold"
              style={{ fontSize: "22px", fontWeight: 700 }}
            >
              {stateHindi} विधानसभा चुनाव 2025 एग्जिट पोल
            </h1>
            <div
              className="mt-4"
              style={{ marginTop: "15px", padding: "10px" }}
            >
              {!electionKeys?.showExitPollTally &&
                exitPoll2024Data?.showExitPoll && (
                  <ExitPollRegionalComponentV2
                    masterKey={masterKey}
                    exitPoll2019Data={exitPoll2019Data}
                    exitPoll2024Data={exitPoll2024Data}
                  />
                )}
            </div>

            {(
              <div className="mx-4 md:mx-4  ">
                <StateExitPoll
                  electionPassedCategory={electionPassedCategory}
                  masterKey={masterKey}
                  stateName={stateName}
                  stateHindi={stateHindi}
                />
              </div>
            )}
          </>
        )}

        {isKeyCandidatesPath && (
          <div className="mx-4">
            <StateKeyCandidate
              stateHindi={stateHindi}
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
            />
          </div>
        )}

        {/* candidate profile page */}
        {isCandidateProfilePath && (
          <div className="mx-4">
            <CandidateProfile
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
              candidateProfileData={candidateProfileData}
              candidateList={candidateList}
            />
          </div>
        )}
      </div>

      {
        <section
          className="mx-5 md:mx-5 md:px-1 "
          id="election-auto-live-blogs"
        >
          {/* <AdSlot300x250
            divId="div-gpt-ad-1659434604998-0"
            minWidth="300px"
            minHeight="250px"
          /> */}
          {size.width < 900 ? (
            <div>
              <List1
                title={"चुनाव न्यूज़ (Election News)"}
                newsListData={
                  firstScroll ? categoryData : categoryNewsListData?.content
                }
                isLCP={true}
                haveH1={false}
                showAds={isMobileDevice ? true : false}
                election={true}
              />
              <div
                className="text-sports news-load h-[50px] w-full mb-4"
                ref={mobileInsightref}
              >
                {loadingSpinner === true && (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div>
              <List2
                title={"चुनाव न्यूज़ (Election News)"}
                newsListData={
                  firstScroll ? categoryData : categoryNewsListData?.content
                }
                isLCP={true}
                showAds={isMobileDevice ? false : true}
                haveH1={false}
              />
              <div
                className="text-sports news-load h-[50px] w-full mb-4"
                ref={insightref}
              >
                {loadingSpinner === true && (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                  </div>
                )}
              </div>
            </div>
          )}

          {categoryNewsListData?.content?.length === 0 &&
            categoryData?.length === 0 && <NoData message="No Data Found" />}

          {/* <Pagination
          handlePageClick={handlePageClick}
          currentPage={currentPage}
          totalPages={totalPages}
        /> */}
        </section>
      }
      <div className="mx-4 md:mx-4 md:px-2 py-2">
        <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659425743360-0"
          minWidth="720px"
          minHeight="90px"
        />{" "}
      </div>
      {electionKeys?.autoLiveBlog && (
        <div className="mx-2">
          <BiharConstituencyLiveResult
            electionPassedCategory={electionPassedCategory}
            electionConfigData={electionKeys}
          />
        </div>
      )}
    </article>
  );
};

export default Index;
